"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDataBase = void 0;
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var utils_1 = require("@dp-instant/utils");
var UserDataBase = (function () {
    function UserDataBase() {
        this.lastSaveCall = NaN;
        this.cache = new Map();
    }
    UserDataBase_1 = UserDataBase;
    UserDataBase.prototype.get = function (k) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var keys, newKeys, obj;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        keys = (Array.isArray(k) ? k : [k]) || [];
                        newKeys = keys.filter(function (key) { return !_this.cache.has(key); });
                        newKeys.forEach(function (key) { return _this.cache.set(key, undefined); });
                        return [4, this.read(newKeys)];
                    case 1:
                        _a.sent();
                        obj = {};
                        keys.forEach(function (_) { return (obj[_] = _this.cache.get(_)); });
                        return [2, obj];
                }
            });
        });
    };
    UserDataBase.prototype.save = function (key, data, delay) {
        var _this = this;
        if (delay === void 0) { delay = UserDataBase_1.DEFAULT_UPLOAD_DELAY; }
        this.cache.set(key, data);
        if (this.canWrite()) {
            this.internalWrite();
        }
        else {
            clearTimeout(this._uploadTimeout);
            this._uploadTimeout = setTimeout(function () {
                _this.internalWrite();
            }, delay);
        }
        return data;
    };
    UserDataBase.prototype.internalWrite = function () {
        this.write();
        this.lastSaveCall = Date.now();
    };
    UserDataBase.prototype.canWrite = function () {
        var now = Date.now();
        if (isNaN(this.lastSaveCall)) {
            this.lastSaveCall = now;
            return false;
        }
        return (now - this.lastSaveCall > UserDataBase_1.FORCED_WRITE_INTERVAL);
    };
    UserDataBase.prototype.erase = function (key) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.cache.set(key, undefined);
                if (this.canWrite()) {
                    this.internalWrite();
                }
                else {
                    clearTimeout(this._uploadTimeout);
                    this._uploadTimeout = setTimeout(function () { return _this.write(); }, UserDataBase_1.DEFAULT_UPLOAD_DELAY);
                }
                return [2, true];
            });
        });
    };
    UserDataBase.prototype.write = function (keys) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var obj;
            return tslib_1.__generator(this, function (_a) {
                obj = {};
                this.cache.forEach(function (v, k) {
                    if (!keys || keys.includes(k)) {
                        obj[k] = v;
                    }
                });
                utils_1.log.trace(this, "write", obj);
                utils_1.log.warn("CookieDataBase::write. Not supported");
                return [2];
            });
        });
    };
    UserDataBase.prototype.read = function (keys) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                utils_1.log.trace(this, "read", keys);
                utils_1.log.warn("CookieDataBase::read. Not supported");
                return [2];
            });
        });
    };
    var UserDataBase_1;
    UserDataBase.DEFAULT_UPLOAD_DELAY = 1000;
    UserDataBase.FORCED_WRITE_INTERVAL = 30000;
    UserDataBase = UserDataBase_1 = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], UserDataBase);
    return UserDataBase;
}());
exports.UserDataBase = UserDataBase;
//# sourceMappingURL=UserDataBase.js.map